import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 96 96",
  "content": "<symbol viewBox=\"0 0 96 96\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-menu\">\n    <title>icon/10pt/菜单</title>\n    <g id=\"icon-menu_icon/10pt/菜单\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\" stroke-linejoin=\"round\">\n        <line x1=\"83.8414258\" y1=\"48\" x2=\"12.000156\" y2=\"48\" id=\"icon-menu_路径-2备份-3\" stroke=\"currentColor\" stroke-width=\"10\" />\n        <line x1=\"83.8414258\" y1=\"73\" x2=\"12.000156\" y2=\"73\" id=\"icon-menu_路径-2备份-5\" stroke=\"currentColor\" stroke-width=\"10\" />\n        <line x1=\"83.8414258\" y1=\"23\" x2=\"12.000156\" y2=\"23\" id=\"icon-menu_路径-2备份-4\" stroke=\"currentColor\" stroke-width=\"10\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu.svg
// module id = dH9r
// module chunks = 3